import originJSONP from 'jsonp'
import qs from 'qs'

export default function jsp(options) {
  let url = options.url + (options.url.indexOf('?') < 0 ? '?' : '&') + `${options.data ? `${qs.stringify(options.data)}` : ''}`
  return new Promise((resolve, reject) => {
    originJSONP(url, options.option, (err, data) => {
      if (!err) {
        resolve(data)
      } else {
        console.log('错误', err)
        reject(err)
      }
    })
  })
}
